import { Outlet, createFileRoute } from '@tanstack/react-router';

import { WhiteGloveLayout } from 'src/sections/white-glove/white-glove-layout';

/**
 * The White Glove chrome. The tenant is already synced by the `$clientId`
 * layout above, so this only supplies the tab bar and the engagement gate.
 */
export const Route = createFileRoute('/_authed/dashboard/o/$orgId/c/$clientId/white-glove')({
  component: WhiteGloveRoute,
});

function WhiteGloveRoute() {
  return (
    <WhiteGloveLayout>
      <Outlet />
    </WhiteGloveLayout>
  );
}
